import { Box, Drawer, IconButton, Tab } from '@mui/material';
import { Tabs } from '@mui/material';
import { styled } from '@mui/material/styles';
import { getDrawerWidth } from '../styles';

export const StyledDrawer = styled(Drawer)(({ open }: { open: boolean }) => ({
  width: getDrawerWidth(open),
  flexShrink: 0,
  height: 'calc(100vh - 94px)',
  '& .MuiDrawer-paper': {
    position: 'absolute',
    overflowY: 'auto',
    width: getDrawerWidth(open),
    zIndex: 1000,
    boxSizing: 'border-box',
  },
}));

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  display: 'flex',
  backgroundColor: theme.palette.primary.main,
  borderRadius: theme.spacing(0.5),
  color: theme.palette.common.white,
  height: 26,
  width: 26,
  '&:hover': {
    backgroundColor: theme.palette.primary.main,
    filter: 'brightness(0.9)',
  },
}));

export const StyledTabs = styled(Tabs)(({ theme }) => ({
  width: '100%',
  borderBottom: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.common.white,
  zIndex: 999,
}));

export const StyledTab = styled(Tab)(({ theme }) => ({
  flex: 1,
  textTransform: 'none',
  padding: 0,
  backgroundColor: theme.palette.common.white,
}));

interface StyledToolbarProps {
  open: boolean;
}

export const StyledToolbar = styled(Box)<StyledToolbarProps>(({ theme, open }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingLeft: `${getDrawerWidth(open) + 24}px `,
  paddingTop: theme.spacing(3),
}));
